import { fromBoolean, pipe, succeed, tap, unbox } from "@otto-ec/assets-core-utils/nano-effect";
import { submitEvent } from "@otto-ec/tracking-bct";

const trackingLabel = "ot_ToTopButton";
let hasShownTrackingFired = false;

export function trackShownOnce(): void {
  pipe(
    fromBoolean(() => !hasShownTrackingFired),
    tap(() => {
      hasShownTrackingFired = true;
      submitEvent({
        [trackingLabel]: ["shown"],
      });
    }),
    unbox(),
  );
}

export function trackClicked(): void {
  pipe(
    succeed(undefined),
    tap(() => {
      submitEvent({
        [trackingLabel]: ["clicked"],
      });
    }),
    unbox(),
  );
}
